import { createStore, applyMiddleware, combineReducers } from "redux";
import { OrderReducer } from "./Orders/orderReducer";
import { historyReducer } from "./OrderHistory/historyReducer";
import { searchReducer } from "./General/searchReducer";
import { loginReducer } from "./Login/LoginReducer";
import { managementReducer } from "./system_management/ManagmentReducer";
import thunk from "redux-thunk";
const rootReducer = combineReducers({
  OrderReducer,
  historyReducer,
  searchReducer,
  loginReducer,
  managementReducer,
});

const Store = createStore(rootReducer, applyMiddleware(thunk));

export default Store;
